var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkdinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4,
    width: 25,
    height: 25,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2012 3H5.46876C4.94662 3 4.44585 3.20742 4.07664 3.57664C3.70742 3.94585 3.5 4.44662 3.5 4.96876V27.7012C3.5 28.2234 3.70742 28.7241 4.07664 29.0934C4.44585 29.4626 4.94662 29.67 5.46876 29.67H28.2012C28.7234 29.67 29.2241 29.4626 29.5934 29.0934C29.9626 28.7241 30.17 28.2234 30.17 27.7012V4.96876C30.17 4.44662 29.9626 3.94585 29.5934 3.57664C29.2241 3.20742 28.7234 3 28.2012 3ZM11.4491 25.7195H7.43938V12.9827H11.4491V25.7195ZM9.44148 11.2177C8.98665 11.2151 8.54276 11.0779 8.16584 10.8233C7.78893 10.5687 7.49588 10.2082 7.32368 9.78717C7.15147 9.36618 7.10784 8.90362 7.19827 8.45785C7.28871 8.01209 7.50917 7.60311 7.83183 7.28252C8.15448 6.96192 8.56487 6.7441 9.01121 6.65652C9.45754 6.56895 9.91982 6.61556 10.3397 6.79046C10.7596 6.96536 11.1182 7.26072 11.3704 7.63926C11.6226 8.0178 11.7569 8.46256 11.7566 8.91741C11.7609 9.22193 11.7038 9.52419 11.5888 9.80619C11.4738 10.0882 11.3032 10.3441 11.0871 10.5588C10.8711 10.7735 10.6141 10.9424 10.3313 11.0556C10.0486 11.1688 9.74597 11.2239 9.44148 11.2177ZM26.2288 25.7306H22.2209V18.7723C22.2209 16.7202 21.3485 16.0868 20.2225 16.0868C19.0334 16.0868 17.8666 16.9832 17.8666 18.8242V25.7306H13.8568V12.992H17.7129V14.757H17.7647C18.1518 13.9736 19.5076 12.6345 21.5763 12.6345C23.8137 12.6345 26.2306 13.9625 26.2306 17.8519L26.2288 25.7306Z",
    fill: "#0A66C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkdinIcon);
export default __webpack_public_path__ + "static/media/linkdin-icon.ecbd3d20e78b1b421c27d23f5be2471c.svg";
export { ForwardRef as ReactComponent };